<template>
  <div>
    <v-data-table
      hide-actions
      :headers="headers"
      :loading="isLoading"
      :items="itemList"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">
          {{ moment(props.item.log_date_time).format("YYYY-MM-DD HH:mm") }}
        </td>
        <td class="text-xs-center">
          {{ props.item.log_user_name }}
        </td>
        <td class="text-xs-center">{{ props.item.log_event_action }}</td>
        <td class="text-xs-center">{{ props.item.log_store_code }}</td>

        <td class="text-xs-center">
          {{ props.item.log_order_code || "-" }}
        </td>
        <td class="text-xs-center">
          {{ props.item.log_product_code || "-" }}
        </td>
      </template>

      <template slot="no-data">
        <div v-if="itemList.length == 0 && isLoading != 'black'">
          No data available
        </div>
        <div v-else>
          <v-progress-circular
            :size="30"
            color="primary"
            indeterminate
          ></v-progress-circular>
          {{ isLoading == "black" ? "Loading data ..." : isLoading }}
        </div>
      </template>
    </v-data-table>
    <div style="display:flex;">
      <v-spacer></v-spacer>
      <div style="width: 50vw" class="my-3">
        <v-pagination
          class="mt-3"
          v-model="config.current_page"
          :length="Math.ceil(config.totalItems / config.page_size)"
          @input="$emit('fetch')"
        ></v-pagination>
      </div>
      <v-spacer></v-spacer>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  props: ["itemList", "isLoading", "config"],
  data: () => ({
    disable_popular: false,
    headers: [
      {
        text: "Date / Time",
        align: "center",
        value: "store_province_name",
        sortable: false,
      },
      {
        text: "First / Last name",
        align: "center",
        value: "store_name_th",
        sortable: false,
      },
      {
        text: "Action",
        align: "center",
        value: "store_name_en",
        sortable: false,
      },
      {
        text: "Store code",
        align: "center",
        value: "store_address_th",
        sortable: false,
      },
      {
        text: "Order code",
        align: "center",
        value: "store_address_en",
        sortable: false,
      },
      {
        text: "Product code",
        align: "center",
        value: "store_address_en",
        sortable: false,
      },
    ],
  }),
  components: {},
  computed: {},
  watch: {},
  created() {},
  methods: {
    moment,
  },
};
</script>

<style scoped>
.popular_toggle {
  position: absolute;
  top: 13px;
  left: 40%;
}
.view-detail-btn {
  font-size: 13px;
  outline: none;
  background-color: #2196f3;
  padding: 5px;
  border-radius: 3px;
  color: white;
  margin: 5px;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.19);
}

.view-detail-btn span {
  outline: none;
}
</style>
